"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var constants_1 = require("../constants");
var hooks_1 = require("../hooks");
var resizeObserver_1 = __importDefault(require("../resizeObserver"));
var useResponsiveContainer = function (_a) {
    var breakpoints = _a.breakpoints;
    var breakpointsRef = react_1.useRef(breakpoints);
    var _b = hooks_1.useClientNode(), node = _b[0], containerRef = _b[1];
    var _c = react_1.useState(null), size = _c[0], setSize = _c[1];
    react_1.useEffect(function () {
        if (!node)
            return;
        resizeObserver_1.default.observe(node);
        var handle = function (_a) {
            var detail = _a.detail;
            var clientWidth = detail.width, clientHeight = detail.height;
            setSize({ clientWidth: clientWidth, clientHeight: clientHeight });
        };
        node.addEventListener(constants_1.eventType, handle);
        return function () {
            resizeObserver_1.default.unobserve(node);
            node.removeEventListener(constants_1.eventType, handle);
        };
    }, [node]);
    var _d = size ||
        node || { clientWidth: null, clientHeight: null }, currentWidth = _d.clientWidth, currentHeight = _d.clientHeight;
    var currentBreakpoints = react_1.useMemo(function () {
        if (!currentWidth)
            return [];
        var breakpointNames = Object.keys(breakpointsRef.current);
        return breakpointNames.filter(function (key) { return currentWidth >= breakpointsRef.current[key]; } // breakpoints[key] is minWidth
        );
    }, [currentWidth]);
    return {
        currentBreakpoints: currentBreakpoints,
        containerRef: containerRef,
        node: node,
        currentWidth: currentWidth,
        currentHeight: currentHeight,
    };
};
exports.default = useResponsiveContainer;
//# sourceMappingURL=useResponsiveContainer.js.map